import { type AmplifyUser } from '@aws-amplify/ui'
import { Auth } from 'aws-amplify'
import { setAmplifyStoreUser, clearAmplifyStore } from './amplifyUser.store'

export const signIn = async (credentials: { username: string; password: string }) => {
    const cleanCredentials = {
        username: credentials.username.trim().toLowerCase(),
        password: credentials.password.trim(),
    }
    const user: AmplifyUser = await Auth.signIn(cleanCredentials)

    setAmplifyStoreUser(user)
    return user
}

type SignOutOptions = { reload?: boolean; clearStore?: boolean }

/** Amplify signout method. Optionally clear stores and reload (default: true) */
export const signOut = async (props?: Parameters<typeof Auth.signOut>[0], options?: SignOutOptions) => {
    const { reload = true, clearStore = true } = options || {}
    const res = await Auth.signOut(props)

    if (clearStore) {
        clearAmplifyStore()
    }

    if (reload) {
        setTimeout(() => {
            /* @ts-expect-error true parameter only works in firefox: https://developer.mozilla.org/en-US/docs/Web/API/Location/reload */
            window.location.reload(true)
        }, 0)
    }

    return res
}

export const currentSession = async () => {
    const session = await Auth.currentSession()
    return session
}

export const completeNewPassword = async (...props: Parameters<typeof Auth.completeNewPassword>) => {
    const [user, newPassword, ...rest] = props
    const cleanPassword = newPassword.trim()
    // Additional argument needed, or there is a cryptic clientMetadata erorr: can't access property "clientMetadata", this._config is undefined
    // Related to: https://github.com/aws-amplify/amplify-js/issues/6634
    // Current type def: AuthClass.completeNewPassword(user: any, password: string, requiredAttributes?: any, clientMetadata?: ClientMetaData): Promise<any>
    // This `thirdArg` allows the exposed method to accept additional arguments if needed, but satisfy the issue above if none are provided
    const thirdArg = rest.length ? rest : [{}]
    const res = await Auth.completeNewPassword(user, cleanPassword, ...thirdArg)
    setAmplifyStoreUser(res)
    return res
}

export const forgotPasswordSubmit = async (...props: Parameters<typeof Auth.forgotPasswordSubmit>) => {
    try {
        const res = await Auth.forgotPasswordSubmit(...props)
        const [username, , password] = props

        if (res === 'SUCCESS') {
            await Auth.signIn(username, password)
            return res
        }

        throw new Error('Something went wrong')
    } catch (error) {
        console.error('forgotPasswordSubmit error', error)
        throw error
    }
}
